import { FC } from "react";
import { displayNumber } from "../utils/formatters";

interface BiensOffMarketHoverPopupProps {
  data: {
    address: string;
    usage?: string;
    m2_habitable?: number;
    m2_terrain?: number;
    prix_demande?: number;
    date_created?: string;
    commentaires?: string;
  };
}

const BiensOffMarketHoverPopup: FC<BiensOffMarketHoverPopupProps> = ({ data }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "white",
        padding: 12,
        borderRadius: 8,
        width: 340,
        boxShadow:
          "rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px",
      }}
    >
      {/* Header with orange indicator */}
      <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
        <div
          style={{
            width: 12,
            height: 12,
            borderRadius: 12,
            backgroundColor: "orange",
            marginRight: 8,
          }}
        />
        <span style={{ 
          textTransform: "uppercase", 
          fontWeight: "bolder", 
          fontSize: 14,
          color: "#ff8c00"
        }}>
          BIEN OFF-MARKET
        </span>
      </div>
      
      {/* Address */}
      <div style={{ 
        fontWeight: "bold", 
        fontSize: 13, 
        marginBottom: 4,
        textTransform: "uppercase"
      }}>
        {data.address}
      </div>
      
      {/* Usage */}
      {data.usage && (
        <div style={{ fontSize: 11, color: "#666", marginBottom: 4 }}>
          {data.usage}
        </div>
      )}
      
      {/* Property details */}
      <div style={{ display: "flex", gap: 12, fontSize: 10, color: "#888" }}>
        {data.m2_habitable && (
          <span>{data.m2_habitable}m² hab.</span>
        )}
        {data.m2_terrain && (
          <span>{data.m2_terrain}m² terrain</span>
        )}
      </div>
      
      {/* Price */}
      {data.prix_demande && (
        <div style={{ 
          fontSize: 12, 
          fontWeight: "bold", 
          color: "#ff8c00",
          marginTop: 4
        }}>
          Prix demandé: {displayNumber(data.prix_demande)} CHF
        </div>
      )}
      
      {/* Comments */}
      {data.commentaires && (
        <div style={{ 
          fontSize: 11, 
          color: "#555",
          marginTop: 6,
          padding: 8,
          backgroundColor: "#f9f9f9",
          borderRadius: 4,
          borderLeft: "3px solid #ff8c00",
          whiteSpace: "pre-wrap",
          maxHeight: "80px",
          overflowY: "auto"
        }}>
          <div style={{ fontWeight: "bold", marginBottom: 4, color: "#ff8c00" }}>
            Commentaires:
          </div>
          {data.commentaires}
        </div>
      )}
      
      {/* Date */}
      {data.date_created && (
        <div style={{ fontSize: 10, color: "#999", marginTop: 4 }}>
          Ajouté le {new Date(data.date_created).toLocaleDateString('fr-CH')}
        </div>
      )}
    </div>
  );
};

export default BiensOffMarketHoverPopup; 